import apiClient from './axiosClient';

export const getCurrentBranch = () => apiClient.get(`/users/get-current-branch/`);
export const getCurrentUser = () => apiClient.get(`/users/`);
export const patchCurrentBranch = (data) => apiClient.patch(`/users/update-current-branch/`, data);